module.exports = __webpack_public_path__ + "static/media/rightCrmIcons.89463acc.png";